import { useSelector } from 'react-redux'
import { selectCompanyInfo } from './store/slice'

const useCheckIsCompanyType = (companyTypes = []) => {
  const companyInfo = useSelector(selectCompanyInfo)

  return companyTypes.includes(companyInfo?.companyType)
}

export default useCheckIsCompanyType
